import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { uniq } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { getLabelFromTag } from './utils';
import useResponsiveButtonSize from '../../utils/useResponsiveButtonSize';
import useWidth from '../../utils/useWidth';
import GridHidden from '../GridHidden';

const getOptionsForTag = tag => data => {
  return uniq(
    data.reduce((acc, p) => {
      if (p.tags) {
        const options = p.tags.filter(t =>
          t.toLowerCase().includes(tag.toLowerCase()),
        );
        return [...acc, ...options];
      } else {
        return acc;
      }
    }, []),
  );
};

const sortOptionsAlphabetical = (a, b) => {
  const labelA = getLabelFromTag(a).toLowerCase();
  const labelB = getLabelFromTag(b).toLowerCase();
  return labelA.localeCompare(labelB);
};

const getActiveTags = (attribute, all) =>
  all.filter(t => t.indexOf(`${attribute}:`) > -1);

const useStyles = makeStyles(theme => ({
  filterTitle: {
    textAlign: 'right',
  },
  filterGroup: {
    marginBottom: theme.spacing(4),
  },
  filterButton: {
    margin: theme.spacing(0, 1, 1, 0),
    display: 'inline-block',
  },
}));

const TagFilter = props => {
  const options = getOptionsForTag(props.filterAttribute)(props.data).sort(
    sortOptionsAlphabetical,
  );
  const availableOptions = getOptionsForTag(props.filterAttribute)(
    props.filteredData,
  );
  const width = useWidth();

  const activeTags = getActiveTags(props.filterAttribute, props.activeFilters);
  const classes = useStyles(props);
  const handleClickAll = () => {
    props.onResetFilter(props.filterAttribute);
  };
  const handleClickFilterButton = tag => {
    props.onClickFilter(tag);
  };
  const buttonSize = useResponsiveButtonSize();

  return (
    <Grid container spacing={2} className={classes.filterGroup}>
      <Grid item xs={2} sm={2} className={classes.filterTitle}>
        <Typography variant={width === 'xs' ? 'body2' : 'h6'}>
          {props.filterAttribute}
        </Typography>
      </Grid>
      <Grid item xs={10} sm={8} style={{display: 'flex', flexWrap: 'wrap', gap: 16}}>
        <Button
          variant={activeTags.length === 0 ? 'contained' : 'outlined'}
          onClick={handleClickAll}
          size={buttonSize}
        >
          Alle
        </Button>
        {options.map(o => (
          <Button
            key={o}
            disabled={!availableOptions.includes(o)}
            onClick={() => handleClickFilterButton(o)}
            variant={activeTags.includes(o) ? 'contained' : 'outlined'}
            size={buttonSize}
          >
            {getLabelFromTag(o)}
          </Button>
        ))}
      </Grid>
      <GridHidden item xsDown mdUp sm={2} />
    </Grid>
  );
};

TagFilter.propTypes = {
  filterAttribute: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  filteredData: PropTypes.array.isRequired,
  onClickFilter: PropTypes.func.isRequired,
  onResetFilter: PropTypes.func.isRequired,
};

export default TagFilter;
